import { useEffect, useMemo, useState } from "react"
import { formatNumber } from "../../../core/utils/common"
import Text from "../../../core/utils/Text"
import { FlexCenter } from "../../../styles/CommonStyles"
import { TextWithMargin } from "../../../styles/OrdersStyle"
import { Column, Row } from "../../../styles/TableStyle"
import { TransactionStatus } from "../../../styles/TransactionHistoryStyles"
import CoinImg from "../../common/CoinImg"
import FilterLayout from "../../layouts/FilterLayout"
import useTransactions from "../../../core/hooks/useTransaction"
import MobileModal from "../../modals/MobileModal"
import WalletHistoryDetailsModal from "./WalletHistoryDetailsModal"

const initialModalState = { show: false, data: null }

const RWalletHistoryTable = () => {

    const [modal, setModal] = useState(initialModalState)
    const onCloseModal = () => setModal(initialModalState)

    const [activeTab, setActiveTab] = useState(1)

    const [type, setType] = useState('wallet')
    const [flow, setFlow] = useState('')

    const {
        bankQueries,
        bankFetching,
        bankTransactions,
        walletQueries,
        walletFetching,
        walletTransactions,
        allPages,
        setBankQueries,
        setWalletQueries,
        bankInitialState,
        walletInitialState,
    } = useTransactions()

    useEffect(() => {
        if (type === 'bank') {
            setBankQueries((prevState) => ({
                ...prevState,
                page: 1,
                query: { ...prevState.query, flow: flow },
            }))
        }
        if (type === 'wallet') {
            setWalletQueries((prevState) => ({
                ...prevState,
                page: 1,
                query: { ...prevState.query, flow: flow },
            }))
        }
    }, [type, flow])

    const transactionsData = useMemo(() => {
        if (type === 'wallet') return walletTransactions
        if (type === 'bank') return bankTransactions
    }, [type, bankFetching, walletFetching])

    return (
        <div className="flex flex-col w-full gap-2">
            <div className="flex rounded-lg bg-primaryBg dark:bg-[#2a2d35] px-2 py-1 w-fit">
                <span onClick={() => { setType("wallet") }} className={`${type === 'wallet' ? "bg-cBlue" : ""} cursor-pointer rounded-lg px-2 py-1 flex items-center justify-center`}><Text className="text-xs" tid={"coining"} /></span>
                <span onClick={() => { setType("bank") }} className={`${type === 'bank' ? "bg-cBlue" : ""} cursor-pointer rounded-lg px-2 py-1 flex items-center justify-center`}><Text className="text-xs" tid={"banking"} /></span>
            </div>
            <FilterLayout
                headers={headers}
                data={
                    type === 'bank' ? bankTransactions : walletTransactions
                }
                totalPages={type === 'bank' ? allPages.BT : allPages.WT}
                // tabbar={<Tabbar />}
                // hasTabbar
                // hasSearchOption={activeTab === 1}
                hasCoinOption={type === 'wallet'}
                hasFlowOptions
                // hasStatusOptions
                state={
                    type === 'bank'
                        ? {
                            filterQueries: bankQueries,
                            setFilterQueries: setBankQueries,
                            initialState: bankInitialState,
                        }
                        : {
                            filterQueries: walletQueries,
                            setFilterQueries: setWalletQueries,
                            initialState: walletInitialState,
                        }
                }
                activeTab={activeTab}
                loading={type === 'bank' ? bankFetching : walletFetching}
            >
                {transactionsData?.data?.map((item) => {
                    return (
                        <Row
                            onClick={() => { setModal({ data: item, show: true }) }}
                            key={item._id}
                        >
                            <Column width="20%">
                                <FlexCenter className="gap-2">
                                    {type === "wallet" && (
                                        <>
                                            <CoinImg id={item.coin} className="w-5 h-5" />
                                            <span>{item.coin.toUpperCase()}</span>
                                        </>
                                    )}
                                    <TextWithMargin type={item.flow}>
                                        <Text tid={item.flow} />
                                    </TextWithMargin>
                                </FlexCenter>
                            </Column>

                            <Column width="20%" number>
                                {item.amount ? formatNumber(item.amount) : "--"}
                            </Column>

                            <Column width="20%">
                                <TransactionStatus status={item.status}>
                                    <Text tid={`T${item.status}`} />
                                </TransactionStatus>
                            </Column>
                        </Row>
                    )
                })}
            </FilterLayout>
            <MobileModal isOpen={modal.show} onClose={onCloseModal}>
                <WalletHistoryDetailsModal data={modal.data} onClose={onCloseModal} type={type} />
            </MobileModal>
        </div>
    )
}

const headers = [
    { title: "type", width: "20%" },
    { title: "amount", width: "20%" },
    { title: "status", width: "20%" },
]

export default RWalletHistoryTable
